module.exports = __webpack_public_path__ + "static/media/footer_1.73451764.png";